import type { MetricStat } from '../types';

const getMockUnitEconomicsStats = (): MetricStat[] => [
    {
        id: 'ltv',
        label: 'LTV',
        value: '$8,420',
        hint: 'ARPA ÷ logo churn',
        tone: 'neutral',
        iconKey: 'ltv',
    },
    {
        id: 'cac',
        label: 'CAC',
        value: '$2,800',
        hint: 'Mock acquisition spend',
        tone: 'neutral',
        iconKey: 'cac',
    },
    {
        id: 'ltv-cac',
        label: 'LTV : CAC',
        value: '3.0:1',
        hint: 'Healthy ≥ 3:1',
        tone: 'positive',
        iconKey: 'ltvCac',
    },
    {
        id: 'payback',
        label: 'Payback',
        value: '5 mo',
        hint: 'Months to recover CAC',
        tone: 'positive',
        iconKey: 'payback',
    },
    {
        id: 'gross-margin-pct',
        label: 'Gross margin %',
        value: '19%',
        hint: 'Benchmark: 70%+ SaaS',
        tone: 'negative',
        iconKey: 'grossMarginPercent',
    },
];

export default getMockUnitEconomicsStats;
